import { Component, Input, OnInit } from '@angular/core';
import { FbGeneralModalConfiguration } from './fb-general-modal.configuration';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'fb-general-modal',
  templateUrl: './fb-general-modal.component.html',
  styleUrls: ['./fb-general-modal.component.scss']
})
export class FbGeneralModalComponent implements OnInit {

  visible: boolean = false;

  constructor( public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
   }

  ngOnInit() { }
  submit(){

    if(this.config.data.configuration.action) this.config.data.configuration.action();
    this.ref.close();

  }

  close(){

    if(this.config.data.configuration.closeAction) this.config.data.configuration.closeAction();
    this.ref.close();

  }

}
